import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=483f2eaf&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RegisterForm.vue?vue&type=style&index=0&id=483f2eaf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483f2eaf",
  null
  
)

export default component.exports